<div class="card shadow-sm border w-100">
  <div class="card-body p-4">

    @if (!form.get('id')?.value) {
      <h5 class="card-title mb-4">new API configuration</h5>
    }
    @if (form.get('id')?.value) {
      <h5 class="card-title mb-4">API configuration #{{ form.get('id')?.value }}</h5>
    }

    <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>

      <div class="mb-3">
        <label for="name" class="form-label fw-semibold text-secondary small text-uppercase">Name</label>
        <input type="text" id="name" class="form-control" placeholder="My API connector" required [class.is-invalid]="isInvalid('name')" formControlName="name"/>
        <div class="invalid-feedback">Name is required.</div>
      </div>

      <div class="mb-3">
        <label for="url-main" class="form-label fw-semibold text-secondary small text-uppercase">URL</label>
        <div class="input-group">
          <input type="url" id="url-main" class="form-control" placeholder="https://api.example.com/endpoint" required [class.is-invalid]="isInvalid('url')" formControlName="url"/>
          <button
            class="btn btn-outline-secondary"
            [class]="testStates['url']"
            type="button"
            [disabled]="testLoading['url']"
            (click)="testUrl('url')">
            @if (testLoading['url']) {
              <span class="spinner-border spinner-border-sm me-1" role="status"></span>
            }
            {{ testLabels['url'] }}
          </button>
          <div class="invalid-feedback">Please enter a valid URL (e.g. https://api.example.com).</div>
        </div>
      </div>

      <div class="mb-3">
        <label for="url-sample" class="form-label fw-semibold text-secondary small text-uppercase">Sample URL</label>
        <div class="input-group">
          <input type="url" id="url-sample" class="form-control" placeholder="https://api.example.com/sample" required [class.is-invalid]="isInvalid('sampleUrl')" formControlName="sampleUrl" />
          <button
            class="btn btn-outline-secondary"
            [class]="testStates['sampleUrl']"
            type="button"
            [disabled]="testLoading['sampleUrl']"
            (click)="testUrl('sampleUrl')"
            >
            @if (testLoading['sampleUrl']) {
              <span class="spinner-border spinner-border-sm me-1" role="status"></span>
            }
            {{ testLabels['sampleUrl'] }}
          </button>
          <div class="invalid-feedback">Please enter a valid sample URL.</div>
        </div>
      </div>

      <div class="mb-3">
        <!--                <div class="col-sm-6">-->
        <label for="items-path" class="form-label fw-semibold text-secondary small text-uppercase">Items path</label>
        <input type="text" id="items-path" class="form-control" formControlName="itemsPath"/>
        <div class="form-text">
          Where to find the records in the response. For example, if your API returns
          <code>&#123; "data": &#123; "items": [...] &#125; &#125;</code>, enter <code>data.items</code>.
          Use <strong>Test</strong> on the URL above to verify — it will fetch the response and confirm
          whether the value at this path is a valid JSON array.
        </div>
        <div class="invalid-feedback">Items path is required.</div>
      <!--                </div>-->
    </div>
    <div class="mb-4">
      <label for="totals-path" class="form-label fw-semibold text-secondary small text-uppercase">Totals path</label>
      <input type="text" id="totals-path" class="form-control"  formControlName="totalPath"/>
      <div class="form-text">
        Where to find the records in the response. For example, if your API returns
        <code>&#123; "data": &#123; "total": [...] &#125; &#125;</code>, enter <code>data.total</code>.
        Use <strong>Test</strong> on the URL above to verify — it will fetch the response and confirm
        whether the value at this path is a valid JSON array.
      </div>
      <div class="invalid-feedback">Totals path is required.</div>
    </div>

    <div class="mb-3">
      <label for="method" class="form-label fw-semibold text-secondary small text-uppercase">Method</label>
      <select id="method" class="form-select" required [class.is-invalid]="isInvalid('method')"  formControlName="method">
        <option value="GET">GET</option>
        <option value="POST">POST</option>
        <option value="PUT">PUT</option>
        <option value="PATCH">PATCH</option>
        <option value="DELETE">DELETE</option>
      </select>
      <div class="invalid-feedback">Please select an HTTP method.</div>
    </div>

    <hr class="my-4" />

    <div class="d-flex align-items-center justify-content-between">
      <div>
        <div class="fw-semibold">Active</div>
        <div class="text-secondary small">Enable this connector</div>
      </div>
      <div class="form-check form-switch mb-0">
        <input class="form-check-input" type="checkbox" role="switch" id="activeToggle" checked formControlName="isActive" />
      </div>
    </div>

    <hr class="my-4" />

    <div class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-outline-secondary" (click)="goToList()">Cancel</button>
      <button type="submit" class="btn btn-dark"  [disabled]="submitting">
        @if (submitting) {
          <span class="spinner-border spinner-border-sm me-1" role="status"></span>
        }
        {{ submitting ? 'Saving…' : 'Save' }}
      </button>
    </div>

  </form>
</div>
</div>